import { render, staticRenderFns } from "./userComment.vue?vue&type=template&id=20c9cd8b&scoped=true"
import script from "./userComment.vue?vue&type=script&lang=js"
export * from "./userComment.vue?vue&type=script&lang=js"
import style0 from "./userComment.vue?vue&type=style&index=0&id=20c9cd8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9cd8b",
  null
  
)

export default component.exports